import optimizeImage from '~/utilities/optimizeImage';

export default function optimizeCardImage(
  imageUrl: string,
  isFallback: boolean
): string {
  return optimizeImage(imageUrl, {
    crop: isFallback ? undefined : '0.8,0.8',
    format: 'auto',
    quality: 90,
    width: 500
  });
}
